import { render } from "./HomeFunFact.vue?vue&type=template&id=5c10ef5a&scoped=true"
import script from "./HomeFunFact.vue?vue&type=script&lang=js"
export * from "./HomeFunFact.vue?vue&type=script&lang=js"

import "./HomeFunFact.vue?vue&type=style&index=0&id=5c10ef5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c10ef5a"]])

export default __exports__